import PropTypes from 'prop-types';

export const implicitSectionPropTypes = {
  index: PropTypes.number,
  active: PropTypes.bool,
  done: PropTypes.bool,
  last: PropTypes.bool,
  mobile: PropTypes.bool,
};
